/* eslint-disable react-hooks/exhaustive-deps */
import { getTourBagHistory } from '@/api/endpoints/getTourBagHistory';
import { PlayerForSaveDto } from '@/api/models';
import { useEffect, useState } from 'react';
import { getHistoryRows, HistoryRow, HistoryRowDetail } from '@/library/ClubHistoryHelper';
import styles from './ClubHistory.module.scss';
import CloseIcon from '@/assets/icons/close-x.svg?react';
import FilterSelect from './FilterSelect';
import { isMobileResolution } from '@/utils';
import { useToast } from '@/context/ToastContext';

export interface IHistoryFields {
  label: string;
  field: string;
  headTypes: number[];
}

const ALL_CHANGES_KEY = 'Show all Changes';
interface IProps {
  tourBagMstrId: number;
  headTypeId: number;
  player: PlayerForSaveDto | null;
  model: string;
  rowGuid: string;
  closeModal: () => void;
}
export default function ClubHistory({ tourBagMstrId, rowGuid, headTypeId, player, model, closeModal }: IProps) {
  const [showModal, setShowModal] = useState(false);
  const [clubHistory, setClubHistory] = useState([] as HistoryRow[]);
  const [clubHistoryFiltered, setClubHistoryFiltered] = useState([] as HistoryRow[]);
  const { showToast } = useToast();

  useEffect(() => {
    const getHistory = async () => {
      try {
        var thisBagHistory = await getTourBagHistory(tourBagMstrId);
        var thisClubHistory = getHistoryRows(rowGuid, headTypeId, thisBagHistory);
        setClubHistory(thisClubHistory);
        setClubHistoryFiltered(thisClubHistory); //by default show all history fields
        setShowModal(true);
      } catch {
        closeModal();
        showToast({ message: 'Failed to retrieve club history', status: 'error' });
      }
    };
    getHistory();
  }, []);

  const handleSelectOptionChanged = (option: string) => {
    //if not filter is set, return all fields
    if (option == ALL_CHANGES_KEY) {
      setClubHistoryFiltered(clubHistory);
    } else {
      //if filter is set, only show the field they selected.
      let filtered = [] as HistoryRow[];
      clubHistory.forEach((h) => {
        let filteredDiffs = [] as HistoryRowDetail[];
        h.diffs.forEach((diff) => {
          if (diff.fieldName === option || (option === 'Hot Melt' && diff.fieldName.includes('Hot Melt ')) || (option === 'Bag Logo' && diff.fieldName.includes('Bag Logo '))) {
            filteredDiffs.push(diff);
          }
        });
        //only show a row if there was a diff for the field the user selected in the dropdown
        if (filteredDiffs.length > 0) {
          let row = new HistoryRow();
          row.date = h.date;
          row.modifyUserName = h.modifyUserName;
          row.diffs = filteredDiffs;
          filtered.push(row);
        }
      });
      setClubHistoryFiltered(filtered);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.navbar}>
          <div>Club History</div>
          {!isMobileResolution && <div className={styles.playerName}>{player?.fullName || ''}</div>}&nbsp;-<div className={styles.playerName}>{model}</div>
          <div className={styles.closeButton}>
            <CloseIcon onClick={closeModal} />
          </div>
        </div>
        <FilterSelect headTypeId={headTypeId} handleSelectOptionChanged={handleSelectOptionChanged} ALL_CHANGES_KEY={ALL_CHANGES_KEY} />
        <div className={styles.historyContainer}>
          {clubHistoryFiltered.map((club, ix) => (
            <div key={ix} className={styles.card}>
              <div className={styles.cardHeader}>
                <div className={styles.date}>{club.date}</div>
                <div className={styles.modifiedBy}>{club.modifyUserName}</div>
              </div>
              {showModal && (
                <>
                  <div style={{ display: 'flex' }}>
                    <div className={styles.cardContainer}>
                      {club.diffs.map((diff, ix) => (
                        <div key={ix} className={styles.cardField}>
                          <div className={styles.fieldName}>{diff.fieldName}</div>
                          <div className={styles.cardHeader}>
                            {diff.previous !== null && <div className={`${styles.diff} ${styles.previous}`}>{diff.previous}</div>}
                            <div className={`${styles.diff} ${styles.current}`}>{diff.current}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
